<template>
    <guide-page v-bind:config="pageConfig" :wxa-page="wxaPage" :wxa-page-param="wxaPageParam" :shareHaderName="shareHaderName"></guide-page>
</template>

<script>
import sensorsdata from 'sa-sdk-javascript';
import GuidePage from '../component/GuidePage.vue';

export default {
  name: 'AccountRecharge',
  components: {
    guidePage: GuidePage,
  },
  data() {
    return {
      wxaPage: 'pages/me/guide/guide-page/guide-page',
      wxaPageParam: 'key=3',
      shareHaderName: '账户充值',
      pageConfig: {
        sections: [
          {
            head: {
              title: '使用官网充值',
            },
            steps: [
              {
                description: [
                  '点击「个人中心」，进入账户充值页面，点击「充值」进入充值页面；',
                ],
                sub: [
                  {
                    images: [
                      {
                        name: '3_01',
                        align: 'left',
                      },
                    ],
                  },
                ],
              },
              {
                description: [
                  '选择充值金额及支付方式，点击「立即充值」，根据提示完成相应操作。',
                ],
                sub: [
                  {
                    images: [
                      {
                        name: '3_02',
                        align: 'left',
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            head: {
              title: '使用小程序充值',
            },
            steps: [
              {
                description: [
                  '进入办签助手小程序，点击「我的」、「充值」，进入账户充值页面；',
                  '选择或输入充值金额，点击「立即支付」完成支付。',
                ],
                sub: [
                  {
                    images: [{ name: '3_03' }],
                  },
                ],
              },
            ],
          },
        ],
      },
    };
  },
  mounted() {
    sensorsdata.track('UserGuide', {
      guide_name: '账户充值',
    });
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/guide/sub/AccountRecharge.vue